import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { Box } from '../../../../units/Box/Box';
import Dropdown from '../../../../units/Dropdown/Dropdown';

class FormDropdown extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired
  };

  renderDropdown = field => (
    <Dropdown {...this.props} value={field.input.value} />
  );

  render() {
    const { name, ...props } = this.props;

    return (
      <Box className="FormDropdown">
        <Field {...props} name={name} component={this.renderDropdown} />
      </Box>
    );
  }
}

export default FormDropdown;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormControls/FormDropdown/FormDropdown.js